module.exports = __webpack_public_path__ + "static/media/banner1.5ca80e3c.png";